var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgGbEng = function SvgGbEng(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 480,
    width: 640,
    viewBox: "0 0 640 480"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h640v480H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1124",
    d: "M281.6 0h76.8v480h-76.8z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ce1124",
    d: "M0 201.6h640v76.8H0z"
  })));
};
export default __webpack_public_path__ + "assets/8f9ff2931a86d56ddc68cfb7cea34ba0.svg";
export { SvgGbEng as ReactComponent };


// WEBPACK FOOTER //
// ./assets/images/flags/4x3/gb-eng.svg